import Vue from 'vue';
import VueRouter from 'vue-router';
import FolderList from '@/components/folderList';
import MessageList from '@/components/messageList';
import MessageListView from '@/components/messageListView';
import MessageView from '@/components/messageView';
import Rules from '@/components/rules';
import ManualRuleEditor from '@/components/manualRuleEditor';
import AutomaticRuleEditor from '@/components/automaticRuleEditor';
import ManualRuleRunner from '@/components/manualRuleRunner';
import Settings from '@/components/settings';
import FolderConfig from '@/components/folderConfig';
import CalendarList from '@/components/calendarList';
import CalendarView from '@/components/calendarView';
import { DateTime } from 'luxon';
import store from '../store';
import SplitView from '@/components/splitView';
import Loading from '@/components/loading';
import Addresses from '@/components/addresses';
// import axios from 'axios';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: to => {
      if (store.state.foldersLoaded) {
        return `/n/${store.getters.getFolderByName('Inbox').id}/1`;
      } else {
        return 'loading';
      }
    }
  },
  {
    path: '/loading',
    name: 'loading',
    components: {
      folders: Loading,
      rightpane: Loading
    }
  },
  {
    path: '/:foldertype([fn])/:folderid(-?\\d+)',
    component: SplitView,
    meta: { sidebarName: 'folder' },
    redirect: to => {
      return `/${to.params.foldertype}/${to.params.folderid}/1`;
    },
    children: [
      {
        path: ':startpos(\\d+)',
        name: 'folder',
        components: {
          folders: FolderList,
          rightpane: MessageList
        },
        props: {
          folders: true,
          rightpane: true
        },
        children: [
          {
            path: '',
            components: {
              bottompane: MessageListView
            },
            props: {
              bottompane: true
            }
          },
          {
            path: ':msgid(\\d+)',
            name: 'foldermsg2',
            components: {
              bottompane: MessageView
            },
            props: {
              bottompane: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/folders',
    name: 'folders',
    component: FolderList
  },
  {
    path: '/:foldertype([fn])/:folderid(-?\\d+)/config',
    component: SplitView,
    children: [
      {
        path: '',
        name: 'folderConfig',
        components: {
          folders: FolderList,
          rightpane: FolderConfig
        },
        props: {
          folders: true,
          rightpane: true
        }
      }
    ]
  },
  {
    path: '/rules',
    name: 'rules',
    component: Rules
  },
  {
    path: '/rules/m/:ruleid(-?\\d+)',
    name: 'manualRuleEditor',
    component: ManualRuleEditor
  },
  {
    path: '/rules/a/:ruleid(-?\\d+)',
    name: 'automaticRuleEditor',
    component: AutomaticRuleEditor
  },
  {
    path: '/rules/run',
    name: 'runManualRules',
    component: ManualRuleRunner
  },
  {
    path: '/account',
    redirect: '/settings'
  },
  {
    path: '/settings',
    redirect: to => {
      return '/settings/general';
    }
  },
  {
    path: '/settings/:page',
    name: 'settings',
    component: Settings
  },
  {
    path: '/addresses',
    name: 'addresses',
    redirect: to => {
      return '/addresses/all';
    }
  },
  {
    path: '/addresses/:book',
    name: 'addressBook',
    component: Addresses
  },
  {
    path: '/addresses/:owner/:folder',
    name: 'addressBookPersonal',
    component: Addresses
  },
  {
    path: '/calendar',
    redirect: to => {
      return `/calendar/week/${DateTime.local().startOf('week').toFormat('yyyyMMdd')}`;
    }
  },
  {
    path: '/calendar/:viewType(day|week|month)/:viewDate(\\d{8})',
    component: SplitView,
    meta: { sidebarName: 'calendar' },
    children: [
      {
        path: '',
        name: 'calendarView',
        components: {
          folders: CalendarList,
          rightpane: CalendarView
        },
        props: {
          folders: true,
          rightpane: true
        }
      },
      {
        path: ':eventId(\\d+|new)',
        name: 'calendarEvent',
        components: {
          folders: CalendarList,
          rightpane: CalendarView
        },
        props: {
          folders: true,
          rightpane: true
        }
      },
      {
        path: ':eventId(\\d+|new)/E/:recurId',
        name: 'calendarEditRecurEvent',
        components: {
          folders: CalendarList,
          rightpane: CalendarView
        },
        props: {
          folders: true,
          rightpane: true
        }
      },
      {
        path: ':eventId(\\d+|new)/:recurId/F',
        name: 'calendarRecurEventFuture',
        components: {
          folders: CalendarList,
          rightpane: CalendarView
        },
        props: {
          folders: true,
          rightpane: true
        }
      },
      {
        path: ':eventId(\\d+|new)/:recurId',
        name: 'calendarRecurEventSingle',
        components: {
          folders: CalendarList,
          rightpane: CalendarView
        },
        props: {
          folders: true,
          rightpane: true
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

/*
router.afterEach((to, from) => {
  if (store.state.internalTrackEnabled) {
    axios.post('http://www.pscs.co.uk/webmailhook', { params: {
      guid: localStorage.getItem('serverGuid'),
      auth: localStorage.getItem('token'),
      action: 'route',
      to: { name: to.name, path: to.path },
      from: { name: from.name, path: from.path }
    } });
  }
}); */

export default router;
